import { Component, OnInit, Input } from '@angular/core';
import { IProductSelect } from '@modules/AccessManager/accessManager.model';

@Component({
  selector: 'sf-product-select',
  templateUrl: './product-select.component.html',
  styleUrls: ['./product-select.component.scss'],
})
export class ProductSelectComponent implements OnInit {

  @Input() productData: IProductSelect[];
  constructor() { }

  ngOnInit() {
  }

}
